export var TrackPlatform = /*#__PURE__*/function (TrackPlatform) {
  TrackPlatform["mixpanel"] = "mixpanel";
  TrackPlatform["ga"] = "ga";
  TrackPlatform["gtag"] = "gtag";
  return TrackPlatform;
}({});